import React from 'react';
import { useState, useEffect } from 'react';
import { Grid, IconButton, Select, MenuItem, FormControl, Chip, Box, ButtonGroup, Tooltip } from '@mui/material';
import { Delete as DeleteIcon, OpenInNew as OpenInNewIcon, Favorite as FavoriteIcon, FavoriteBorder as FavoriteBorderIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, Article as ArticleIcon, ArticleOutlined as ArticleOutlinedIcon, Campaign as CampaignIcon, AutoStories as AutoStoriesIcon, ExploreOff as ExploreOffIcon } from '@mui/icons-material';
import VoteButtons from './VoteButtons';
import  db  from '../firebase'; // Adjust the import according to your project structure
import { doc, updateDoc } from 'firebase/firestore';
import {useAuth} from '../contexts/AuthContext';
import ArticleEditor from './ArticleEditor';
import InsightfulButton from './InsightfulButton';

const ArticleCardActions = React.memo(({ article, handleDelete, handleExtractArticle, handleTagChange, availableTags, handleExpandClick, handleGenerateTLDR, expandedArticleId, handleFavoriteArticle, handleDialogOpen }) => {
  const [currentCategory, setCurrentCategory] = useState(article.category || null);
  const {currentUser}= useAuth();


  // Update local state when article.category changes
  useEffect(() => {
    setCurrentCategory(article.category || null);
  }, [article.category]);

  const handleCategoryChange = async (newCategory) => {
    try {
      const updatedCategory = currentCategory === newCategory ? null : newCategory;
      await updateDoc(doc(db, 'articles', article.id), {
        category: updatedCategory
      });
      setCurrentCategory(updatedCategory); // Update local state immediately
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <InsightfulButton article={article} />
        <IconButton onClick={() => handleDialogOpen(article)}>
          <OpenInNewIcon color='primary'/>
        </IconButton>
        <VoteButtons article={article} />

        {currentUser?.isAdmin && (
          <ButtonGroup size="small" className='vote-buttons' sx={{ ml: 1, bgcolor: 'background.paper',
    '& .MuiIconButton-root': {
      border: '1px solid rgba(255, 255, 255, 0.12)',
      borderRadius: 0}}}>
            <Tooltip title="Like">
              <IconButton 
                onClick={() => handleCategoryChange('liked')}
                color={currentCategory === 'liked' ? 'primary' : 'default'}
              >
                {currentCategory === 'liked' ? 
                  <FavoriteIcon /> : <FavoriteBorderIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Breaking News">
              <IconButton 
                onClick={() => handleCategoryChange('breaking')}
                color={currentCategory === 'breaking' ? 'error' : 'default'}
              >
                <CampaignIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Beyond Feed">
              <IconButton 
                onClick={() => handleCategoryChange('beyond')}
                color={currentCategory === 'beyond' ? 'secondary' : 'default'}
              >
                <ExploreOffIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Long Read">
              <IconButton 
                onClick={() => handleCategoryChange('longread')}
                color={currentCategory === 'longread' ? 'info' : 'default'}
              >
                <AutoStoriesIcon />
              </IconButton>
            </Tooltip>
            <ArticleEditor article={article} />
          </ButtonGroup>
        )}
      </Box>
    </>
  );
});

export default ArticleCardActions;
